import { useNavigate } from "react-router-dom";
import { LogOut, ExternalLink } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { useAuth } from "@/context/AuthContext";
import OrdersPanel from "@/components/admin/OrdersPanel";
import MenuManagerPanel from "@/components/admin/MenuManagerPanel";
import SettingsPanel from "@/components/admin/SettingsPanel";

export default function StaffDashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => { await logout(); navigate("/login"); };

  return (
    <div className="min-h-screen bg-[#FAF6F0]">
      <header className="sticky top-0 z-40 border-b border-stone-800 bg-stone-900 text-stone-100">
        <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6">
          <div className="flex items-center gap-3">
            <img src="/logo.png" alt="Flavors" className="h-9 w-9 rounded-full ring-1 ring-amber-500/40" />
            <div>
              <div className="font-display font-bold text-amber-400">Staff Dashboard</div>
              <div className="text-xs text-stone-400">{user?.email}</div>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <a href="/" className="flex items-center gap-1.5 rounded-full px-3 py-2 text-sm text-stone-300 hover:bg-stone-800"><ExternalLink className="h-4 w-4" /> View Site</a>
            <button data-testid="logout-button" onClick={doLogout} className="flex items-center gap-1.5 rounded-full bg-stone-800 px-4 py-2 text-sm font-semibold hover:bg-stone-700"><LogOut className="h-4 w-4" /> Logout</button>
          </div>
        </div>
      </header>

      <div className="mx-auto max-w-6xl px-4 py-8 sm:px-6">
        <Tabs defaultValue="orders">
          <TabsList className="mb-6">
            <TabsTrigger value="orders" data-testid="staff-tab-orders">Orders</TabsTrigger>
            <TabsTrigger value="availability" data-testid="staff-tab-availability">Item Availability</TabsTrigger>
            <TabsTrigger value="controls" data-testid="staff-tab-controls">Controls</TabsTrigger>
          </TabsList>
          <TabsContent value="orders"><OrdersPanel /></TabsContent>
          <TabsContent value="availability"><MenuManagerPanel canEdit={false} /></TabsContent>
          <TabsContent value="controls"><SettingsPanel canEditAll={false} /></TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
